module.exports = __webpack_public_path__ + "img/neoenergia-pe.8119d701.png";